import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import ELogo from "../ELogo";
import { getMobileStoreUrl } from "../../content/homeMarketing";
import "../MarketingPages.css";

export default function MobileAppBanner({ t, lang }) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div
      className={`mobile-app-banner ${lang === "ar" ? "rtl" : ""}`}
      role="region"
      aria-label={t.mobileAppBannerTitle}
    >
      <button
        type="button"
        className="mobile-app-banner__dismiss"
        onClick={() => setDismissed(true)}
        aria-label={t.mobileAppBannerDismiss}
      >
        <IoClose aria-hidden="true" />
      </button>

      <div className="mobile-app-banner__icon" aria-hidden="true">
        <ELogo size="small" />
      </div>

      <div className="mobile-app-banner__copy">
        <p className="mobile-app-banner__title">{t.mobileAppBannerTitle}</p>
        <p className="mobile-app-banner__subtitle">{t.mobileAppBannerSubtitle}</p>
      </div>

      <a
        className="mobile-app-banner__cta"
        href={getMobileStoreUrl()}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t.mobileAppBannerCta}
      </a>
    </div>
  );
}
